var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import Form from "./forms/BironexForm";
import CreateForm from "./forms/CreateBironexForm";
import UsdtForm from "./forms/UsdtForm";
import { PAYMENT_PROVIDERS } from "../../containers/app/payment-providers";
import { clearUsdtState as clearUsdtStateAction } from "../../actions/recharge/creators/usdt";
var messages = defineMessages({
    choose_recharge: {
        id: "join.refill_title",
        defaultMessage: "Choose a method to create account"
    },
    recharge_through: {
        id: "recharge.through",
        defaultMessage: "Пополнение через"
    }
});
var BironexRecharge = /** @class */ (function (_super) {
    __extends(BironexRecharge, _super);
    function BironexRecharge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedPayment: null
        };
        _this.handleClearSelectedPayment = function () {
            _this.props.clearUsdtStateAction();
            if (_this.state.selectedPayment) {
                _this.props.clearProps();
                _this.setState({ selectedPayment: null });
            }
            else {
                _this.props.history.push("/");
            }
        };
        _this.onPaymentSelect = function (providerLabel) {
            if (_this.state.selectedPayment !== providerLabel) {
                _this.props.clearProps();
                _this.props.clearUsdtStateAction();
            }
            _this.setState({
                selectedPayment: providerLabel
            });
        };
        _this.rendererOpex = function () {
            var _a = _this.props, recharge = _a.recharge, pin = _a.pin, user = _a.user;
            var amount = recharge.get("amount");
            var error = recharge.get("error");
            var createError = recharge.get("createError");
            var result = recharge.get("result");
            var currency = _this.props.currency;
            var fetching = recharge.get("fetching");
            var timeout = recharge.get("timeout");
            var attempts = recharge.get("attempts");
            var maxAttempts = recharge.get("max");
            if (result === 0) {
                _this.props.history.push("/recharge/success");
            }
            return (_jsx("div", __assign({ className: "forms" }, { children: amount === undefined ? (_jsx(Form, { submitAction: function (data) { return _this.props.handleSubmit(data, false); }, fetching: fetching, languageId: _this.props.languageId, errorCode: error, timeout: timeout, attempts: attempts, maxAttempts: maxAttempts, gamblerId: user.gamblerId, onBlockExpire: _this.props.onBlockExpire })) : (_jsx(CreateForm, { amount: amount, createError: createError, currency: currency, handleCreate: function () { return _this.props.handleCreate(false); }, fetching: fetching, pin: pin })) })));
        };
        _this.rendererUsdt = function () {
            return (_jsx("div", __assign({ className: "forms" }, { children: _jsx(UsdtForm, { handleClearSelect: _this.handleClearSelectedPayment }) })));
        };
        _this.renderActiveForm = function () {
            var selectedPayment = _this.state.selectedPayment;
            if (selectedPayment === "bironex") {
                return _this.rendererOpex();
            }
            if (selectedPayment === "USDT") {
                return _this.rendererUsdt();
            }
            return null;
        };
        return _this;
    }
    BironexRecharge.prototype.componentWillUnmount = function () {
        this.props.clearProps();
        this.props.clearUsdtStateAction();
    };
    BironexRecharge.prototype.render = function () {
        var _this = this;
        var selectedPayment = this.state.selectedPayment;
        var listClass = "providers__list" + (selectedPayment ? " providers__list-selected" : "");
        return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: "new-recharge__head" }, { children: [_jsx("a", { className: "new-join__back", style: { cursor: "pointer" }, onClick: this.handleClearSelectedPayment }), selectedPayment ? (this.props.intl.formatMessage(messages.recharge_through) +
                            " " +
                            selectedPayment.toUpperCase()) : (_jsx(FormattedMessage, __assign({}, messages.choose_recharge)))] })), _jsx("div", __assign({ className: listClass }, { children: PAYMENT_PROVIDERS.map(function (provider) {
                        var active = selectedPayment === provider.label;
                        return (_jsx("div", __assign({ className: "providers__list__item-wrapper", onClick: function () { return _this.onPaymentSelect(provider.label); } }, { children: _jsx("div", __assign({ className: classNames("providers__list__item", {
                                    active: active
                                }) }, { children: _jsx("img", { width: "auto", height: "40px", alt: provider.label, src: provider.img }) })) }), provider.label));
                    }) })), selectedPayment && (_jsx("div", __assign({ className: "new-recharge__wrapper", style: { padding: "20px" } }, { children: _jsx("div", __assign({ className: "toggle_content" }, { children: _jsx("div", __assign({ className: "body" }, { children: this.renderActiveForm() })) })) })))] }));
    };
    return BironexRecharge;
}(Component));
BironexRecharge.propTypes = {
    user: PropTypes.object.isRequired,
    intl: PropTypes.object,
    languageId: PropTypes.number.isRequired,
    recharge: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    pin: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleCreate: PropTypes.func.isRequired,
    clearProps: PropTypes.func.isRequired,
    onBlockExpire: PropTypes.func.isRequired,
    clearUsdtStateAction: PropTypes.func.isRequired,
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({ clearUsdtStateAction: clearUsdtStateAction }, dispatch);
};
export default injectIntl(withRouter(connect(null, mapDispatchToProps)(BironexRecharge)));



// WEBPACK FOOTER //
// ./src/components/recharge/Bironex.jsx